import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import { toast } from "react-toastify";
import PaymentInfor from "../../../phan-he-thu-ngan/components/PaymentInfor";
import { OctTable } from "@oceantech/oceantech-ui";
import NumberField from "../../../component/number-field";
import { useContext, useEffect, useRef, useState } from "react";
import { CODE } from "../../../utils/Constant";
import { Col, Form, Row } from "react-bootstrap";
import { AppContext } from "../../../appContext/AppContext";
import LabelRequired from "../../../component/LabelRequired";
import WfButton from "../../../workflows/components/WfButton";
import AutocompleteV2 from "../../../component/AutocompleteObjectV2";
import { LIST_HINH_THUC, PATIENT_TYPE, WF_STATUS_ID } from "../../../phan-he-thu-ngan/const/ThuNganConstant";
import { ConfirmDialog } from "../../../component/ConfirmDialog";
import { formatDateToDDMMYYYY } from "../../../utils/FormatUtils";
import { ColumnThongTinThuoc, ColumnThongTinThuocChoDuyet } from "./const/ThuNganColumns";
import { cancelApproval, getDsThuocXuatKho, ReasonForCancelApproval } from "../../services/servicesXuatKho";
import { EnterReasonDialog } from "../../../component/EnterReasonDialog";
import "../../PhanHeXuatKho.scss"


type Props = {
  warehouseId?: any;
  selectedRow: any;
  setSelectedRow: React.Dispatch<any>;
  dsVatTu: any;
  handleRefreshData: (row: any, isUpdateSummaryStatus?: boolean, isUpdateDsBenhNhan?: boolean) => void;
  setDsVatTu: React.Dispatch<any>;
  warehouseExportType: any;
};
const validationSchema = Yup.object({
  discount: Yup.number().min(0, "Miễn giảm trong khoảng 0-100%").max(100, "Miễn giảm trong khoảng 0-100%"),
});

const ThongTinPhieuXuat = (props: Props) => {
  const { selectedRow, setSelectedRow, dsVatTu, setDsVatTu, warehouseId, handleRefreshData, warehouseExportType } = props;
  const { setIsLoading } = useContext(AppContext);
  const [invoicesInfor, setInvoicesInfor] = useState<any>({
    discount: '',
  });

  const [cancelInfor, setCancelInfor] = useState<any>();
  const [paymentItem, setPaymentItem] = useState<any>([]);
  const [dataReqWorkflow, setDataReqWorkflow] = useState<any>({});
  const [workflow, setWorkflow] = useState<any>();
  const submitFormRef = useRef<() => void>(() => { });

  const onSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      const dataSubmit = {
        slipDto: {
          ...values,
        },
        lstItem: [],
      };
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetPaymentInfor = (data: any) => {
    setPaymentItem([
      {
        code: "amount",
        name: "Tổng chi phí:",
        value: data?.amount,
        type: "price",
      },
      // {
      //   code: "collected",
      //   name: "Đã thu:",
      //   value: data?.collected,
      //   type: "price",
      // },
      // {
      //   code: "discount",
      //   name: "Miễn giảm:",
      //   value: data?.discount,
      //   type: "percent",
      // },
      // {
      //   code: "notCollected",
      //   name: "Còn nợ:",
      //   value: data?.notCollected,
      //   type: "price",
      //   color: "text-danger",
      // },
    ]);
  };

  useEffect(() => {
    if (cancelInfor) handleSetPaymentInfor(cancelInfor);
    else handleSetPaymentInfor(selectedRow);
  }, [selectedRow, cancelInfor]);

  useEffect(() => {
    if (selectedRow?.id) {
      const rowData = selectedRow || {};
      setInvoicesInfor({
        invDate: rowData.code ? new Date() : '',
        loaiPhieu: rowData.code ? 'Thu tiền' : '',
        cashierName: rowData.cashierName || '',
        id: rowData.id,
        code: rowData.code,
        amount: rowData.amount,
        method: LIST_HINH_THUC.find(method => method.code === rowData.method)?.code || LIST_HINH_THUC[0].code,
        methodName: LIST_HINH_THUC.find(method => method.code === rowData.method)?.name || LIST_HINH_THUC[0].name,
        reasonDis: rowData.reasonDis,
        contents: rowData.contents,
        discount: rowData.discount,
        receiptNumber: rowData.receiptNumber,
        mateWhId: rowData.mateWhId,
        mateWhName: rowData.mateWhName,
        collected: rowData.collected,
        priceReceived: rowData.priceReceived,
        priceReturn: rowData.priceReturn,
      });
    } else {
      setInvoicesInfor({});
    };
    setCancelInfor(null);
  }, [selectedRow]);

  const handleRefreshStatusColor = () => {
    const rowElement = document.getElementById(`lz-row-table-${selectedRow.id}`);
    if (rowElement) {
      const iconElement = rowElement.querySelector('i.bi-circle-fill') as HTMLElement;
      if (iconElement) {
        iconElement.style.color = selectedRow.color;
      }
    }
  };

  useEffect(() => {
    workflow?.currId === WF_STATUS_ID.PAID && !workflow.firstTime && submitFormRef.current();
    setTimeout(() => {
      workflow?.currCode && handleRefreshData(selectedRow, true);
    }, 300);
  }, [workflow?.currCode, workflow?.currId]);

  useEffect(() => {
    handleRefreshStatusColor();
  }, [selectedRow.color]);

  const handleCloseDialog = () => {
    setDataReqWorkflow({});
  };

  const getDsVatTu = async (slipId: string) => {
    setIsLoading(true);
    try {
      const { data } = await getDsThuocXuatKho({ slipId: slipId });
      if (CODE.SUCCESS === data.code) {
        setDsVatTu(data.data.content);
      } else {
        toast.error('Lỗi tải danh sách thuốc/VT, vui lòng thử lại')
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (cancelInfor) {
      getDsVatTu(cancelInfor?.id);
    } else if (selectedRow.id) {
      getDsVatTu(selectedRow.id);
    }
  }, [cancelInfor]);

  const handleApproveReq = async (values?: any) => { // nhập lý do từ chối duyệt
    try {
      setIsLoading(true);
      const { data } = await cancelApproval(values, selectedRow.id);
      if (CODE.SUCCESS === data.code) {
        dataReqWorkflow.submit && dataReqWorkflow.submit();
        handleCloseDialog();
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại')
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlerCancelApproval = async (values?: any) => { // nhập lý do huỷ duyệt
    try {
      setIsLoading(true);
      const { data } = await ReasonForCancelApproval(values, selectedRow.id);
      if (CODE.SUCCESS === data.code) {
        dataReqWorkflow.submit && dataReqWorkflow.submit();
        handleCloseDialog();
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại')
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="TTVienPhi">
      <div className="bg-white spaces pt-6 pb-10 spaces fl-1">
        <OctTable
          className={`custom-header-table table-view-ds-xuat-bh`}
          columns={ColumnThongTinThuoc}
          data={dsVatTu || []}
          noToolbar
          clearToolbar
          noPagination
          fixedColumnsCount={-1}
        />
      </div>
      <div>
        {/* <PaymentInfor
          className="price-info"
          paymentData={paymentItem}
        /> */}
        <div className="spaces ml-10 border-top fl-4">
          <Formik
            enableReinitialize
            initialValues={cancelInfor ? cancelInfor : invoicesInfor}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleSubmit, setFieldValue }) => {
              submitFormRef.current = handleSubmit;
              return (
                <>
                  <Form onSubmit={handleSubmit} id="form-vien-phi">
                    <div>
                      <div className="flex-grow-1 mb-2 bg-white pe-3">
                        <div>
                          <Row>
                            {/* <Col xs={3}>
                              <div className="label-input-group mt-2">
                                <TextField
                                  label="Số phiếu"
                                  labelClassName="min-w-105px"
                                  className="input flex"
                                  name="receiptNumber"
                                  type="text"
                                  value={values?.receiptNumber || ""}
                                  disabled
                                />
                              </div>
                            </Col> */}
                            {/* <Col xs={3}>
                              <div className="label-input-group mt-2">
                                <TextField
                                  label="Người thu"
                                  labelClassName="min-w-100px"
                                  className="input flex"
                                  name="cashierName"
                                  type="text"
                                  value={values?.cashierName || ""}
                                  disabled={true}
                                />
                              </div>
                            </Col> */}
                            {/* <Col xs={3}>
                              <div className="label-input-group mt-2">
                                <TextField
                                  label="Ngày thu"
                                  labelClassName="min-w-80px"
                                  className="input flex"
                                  name="invDate"
                                  type="text"
                                  value={values.invDate ? moment(values.invDate).format("DD/MM/YYYY") : cancelInfor ? formatDateToDDMMYYYY(cancelInfor.doCreation) : ''}
                                  disabled
                                />
                              </div>
                            </Col> */}
                            {/* <Col xs={3}>
                              <div className="label-input-group mt-2">
                                <TextField
                                  label="Loại phiếu"
                                  labelClassName="min-w-90px"
                                  className="input flex"
                                  name="loaiPhieu"
                                  type="text"
                                  value={values.loaiPhieu}
                                  disabled
                                />
                              </div>
                            </Col> */}
                            {/* <Col xs={3}>
                              <div className="label-input-group mt-2">
                                <NumberField
                                  label="Số tiền"
                                  labelClassName="min-w-105px"
                                  className="input no-spinners text-end invTotal"
                                  name="amount"
                                  value={values?.amount || 0}
                                  disabled
                                  onChange={(value: number) => setFieldValue("amount", value)}
                                />
                              </div>
                            </Col> */}
                          </Row>
                        </div>
                      </div>
                      <div className="flex justify-content-start pe-2 pb-1 mt-3 wf-tu-truc">
                        {(!cancelInfor) && warehouseExportType?.tracker &&
                          <WfButton
                            handleClick={(data) => setDataReqWorkflow(data)}
                            additionalFunc={(workflow) => {
                              setWorkflow(workflow);
                            }}
                            tracker={warehouseExportType?.tracker}
                            objectId={selectedRow?.id}
                          />
                        }
                        {
                          (selectedRow?.reasonForCancel
                            // ((workflow?.currId === WF_STATUS_ID.CANCEL || workflow?.currId === WF_STATUS_ID.WAIT_APPROVE))
                            // || cancelInfor
                          ) &&
                          <div className="flex-grow-1 mb-2 bg-white pe-3">
                            <Col xs={4} className="pt-2 d-flex">
                              <span className="text-lable-input min-w-70px">
                                Lý do từ chối:
                              </span>
                              <span className="color-red text-ellipsis-content">
                                {selectedRow?.reasonForCancel || ""}
                              </span>
                            </Col>
                          </div>
                        }

                      </div>
                    </div>
                  </Form>

                  {
                    dataReqWorkflow?.componentName === "ConfirmDialog" &&
                    <ConfirmDialog
                      show={dataReqWorkflow?.componentName === "ConfirmDialog"}
                      title={`Xác nhận ${dataReqWorkflow.reqName}`}
                      message={`Bạn chắc chắn muốn ${dataReqWorkflow.reqName} ?`}
                      close="Đóng"
                      onCloseClick={handleCloseDialog}
                      yes="Xác nhận"
                      onYesClick={() => {
                        dataReqWorkflow.submit && dataReqWorkflow.submit();
                        handleCloseDialog();
                      }}
                    />
                  }

                  {
                    dataReqWorkflow?.componentName === "DialogEnterReason" &&
                    <EnterReasonDialog
                      show={dataReqWorkflow?.componentName === "DialogEnterReason"}
                      title={`Xác nhận ${dataReqWorkflow.reqName}`}
                      onHide={handleCloseDialog}
                      onSubmit={handleApproveReq}
                    />
                  }

                  {
                    dataReqWorkflow?.componentName === "DialogEnterReasonForCancelApproval" &&
                    <EnterReasonDialog
                      show={dataReqWorkflow?.componentName === "DialogEnterReasonForCancelApproval"}
                      title={`Xác nhận ${dataReqWorkflow.reqName}`}
                      onHide={handleCloseDialog}
                      onSubmit={handlerCancelApproval}
                      fieldName="reasonForCancelApproval"
                    />
                  }
                </>
              );
            }}
          </Formik>
        </div>
      </div>
    </div >
  );
};
export default ThongTinPhieuXuat;
